
<template>
    <ChannelsGeneral title="Email" grey="true">
        <template #content>
            <p>
                Email is essential — but traditional inboxes create chaos. Yabbr brings Email into the same workspace as SMS, MMS, Voice, and Web Chat, so your team has <b>one consistent place</b> to manage customer communications. <br><br>
                No more switching systems or losing the thread. Every interaction is tracked, branded, and professional.
            </p>
        </template>
        <template #img>
            <v-img
            src="../assets/img/email.png"
            max-width="500px"
            alt="Email message composer"
            contain />
        </template>
    </ChannelsGeneral>
</template>

<script>
import ChannelsGeneral from './ChannelsGeneral.vue'

export default {
    name: 'ChannelsEmail',
    components: {
    ChannelsGeneral
    }
}
</script>

<style lang="scss">
</style>